export default "__VITE_ASSET__qrmBIK_c__"